import { constObjectGenerator } from "../../../../../common/utils/utilsEx";

export const loadDynamicContentAT = constObjectGenerator(
    ["hasCustomerConfig", "hasCustomerInfo"],
    "um/{key}/loadDynamicContentFeature"
);

export interface ILoadDynamicContentState {
    config: ICustomerConfig;
    info: ICustomerInfo;
}

export interface ICustomerConfig {
    firstNameField: string;
    lastNameField: string;
    identifyScreenTexts: any;
    editScreenTexts: any;
}

export interface ICustomerInfo {
    Name: string;
    OrganizationNo: string;
    WebPage: string;
    Addresses: ICustomerInfoAddresses[];
    Logo: {
        Dark: string;
        Light: string;
    };
}

export interface ICustomerInfoAddresses {
    Title: string;
    AddressLine: string;
    ZipCode: string;
    City: string;
    Country: string;
    Phone: string;
    Email: string;
    IsDefault: boolean;
}
